import React,{useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography'; 
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container'; 
import DBLayout from '../../components/DBLayout';  
import SavedCards from '../../components/SavedCards'
import SavedAddress from '../../components/SavedAddress'
import BankDetails from '../../components/BankDetails'
import './sdcard.css';

const TabPanel = ({ children, value, index, ...other }) => { 
  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  return {
    id: `buyer-dashboard-${index}`,
    'aria-controls': `buyer-dashboard-tabpanel-${index}`
  };
}

const SavedDetails = props => {
  const [value, setValue] = useState(0);

  

  const handleChange = (event, newValue) => setValue(newValue);
  // console.log("++++++++++++++++++",props.history.location.state.id)
  return (
    <DBLayout title="Saved Details"> 
      <Container className="db-bids-wrapper mt-4 customTabs pw-box"> 
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="buyer-dashboard" 
        >
          <Tab label="Saved cards" {...a11yProps(0)} />
          <Tab label="Bank details" {...a11yProps(1)} />
          <Tab label="Saved addresses" {...a11yProps(2)} /> 
        </Tabs>
        <TabPanel value={value} index={0}>  
           <SavedCards id={props.history.location.state?props.history.location.state.id:""} />
        </TabPanel>
        <TabPanel value={value} index={1}> 
           <BankDetails /> 
        </TabPanel>
        <TabPanel value={value} index={2}> 
          <SavedAddress />
        </TabPanel> 
      </Container>
    </DBLayout>
  );
};

export default SavedDetails;
